import { __decorate } from "tslib";
import Component from 'vue-class-component';
import ReactiveComponent from "@/components/ReactiveComponent";
import authService from "@/services/authService";
let Dashboard = class Dashboard extends ReactiveComponent {
    logout() {
        authService.logout();
    }
};
Dashboard = __decorate([
    Component({})
], Dashboard);
export default Dashboard;
